var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGoogle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 162,
  height: 48,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M156 0H6a6 6 0 0 0-6 6v36a6 6 0 0 0 6 6h150a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#A6A6A6",
  d: "M156 .96A5.04 5.04 0 0 1 161.04 6v36a5.04 5.04 0 0 1-5.04 5.04H6A5.04 5.04 0 0 1 .96 42V6A5.04 5.04 0 0 1 6 .96zm0-.96H6a6 6 0 0 0-6 6v36a6 6 0 0 0 6 6h150a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.2,
  d: "M56.904 12.288a3.26 3.26 0 0 1-.9 2.4 3.48 3.48 0 0 1-2.64 1.056 3.6 3.6 0 0 1-2.652-1.08 3.83 3.83 0 0 1 0-5.352 3.79 3.79 0 0 1 4.128-.78c.433.178.818.453 1.128.804l-.636.636a2.4 2.4 0 0 0-1.968-.864 2.88 2.88 0 1 0 2.016 4.956c.366-.402.579-.92.6-1.464h-2.616v-.864h3.492q.04.275.048.552ZM62.4 9.288h-3.24v2.28h2.952v.864H59.16v2.28h3.24v.888h-4.176V8.4H62.4zM66.336 15.6h-.924V9.288h-2.016V8.4H68.4v.888h-2.064zM71.928 15.6V8.4h.924v7.2zM76.956 15.6h-.924V9.288h-2.016V8.4h4.944v.888h-2.004zM88.332 14.664a3.734 3.734 0 0 1-5.28 0 3.89 3.89 0 0 1 0-5.328 3.52 3.52 0 0 1 2.64-1.092 3.6 3.6 0 0 1 2.64 1.092A3.68 3.68 0 0 1 89.388 12a3.6 3.6 0 0 1-1.056 2.664Zm-4.596-.6a2.75 2.75 0 0 0 3.912 0 3.05 3.05 0 0 0 0-4.128 2.75 2.75 0 0 0-3.912 0 3.05 3.05 0 0 0 0 4.128ZM90.696 15.6V8.4h1.116l3.504 5.604V8.4h.924v7.2h-.96l-3.66-5.868V15.6z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M81.768 26.1a5.112 5.112 0 1 0 5.124 5.1 5.027 5.027 0 0 0-5.124-5.1m0 8.196a3.096 3.096 0 1 1 2.88-3.096 2.95 2.95 0 0 1-2.88 3.096M70.584 26.1a5.112 5.112 0 1 0 5.124 5.1 5.027 5.027 0 0 0-5.124-5.1m0 8.196a3.096 3.096 0 1 1 2.88-3.096 2.95 2.95 0 0 1-2.88 3.096m-13.296-6.624v2.16h5.184a4.52 4.52 0 0 1-1.2 2.724 5.3 5.3 0 0 1-4.008 1.584 5.76 5.76 0 0 1 0-11.52 5.57 5.57 0 0 1 3.936 1.548l1.524-1.524a7.56 7.56 0 0 0-5.436-2.184 7.932 7.932 0 1 0 0 15.852 7.28 7.28 0 0 0 5.532-2.22 7.2 7.2 0 0 0 1.872-5.076 7.5 7.5 0 0 0-.108-1.344zm54.372 1.68a4.8 4.8 0 0 0-4.368-3.252 4.8 4.8 0 0 0-4.8 5.1 5.075 5.075 0 0 0 9.312 2.844l-1.74-1.2a2.9 2.9 0 0 1-2.508 1.404 2.58 2.58 0 0 1-2.472-1.548l6.828-2.82zm-6.96 1.704a2.81 2.81 0 0 1 1.599-2.72c.338-.16.704-.251 1.077-.268a1.97 1.97 0 0 1 1.884 1.092zM99.156 36h2.244V21h-2.244zm-3.672-8.76H95.4a3.53 3.53 0 0 0-2.688-1.2 5.112 5.112 0 0 0 0 10.212 3.46 3.46 0 0 0 2.688-1.2h.084v.732c0 1.956-1.044 3-2.724 3a2.83 2.83 0 0 1-2.58-1.812l-1.944.804A4.8 4.8 0 0 0 92.76 40.8c2.628 0 4.8-1.548 4.8-5.316V26.4h-2.076zm-2.58 7.056a3.096 3.096 0 0 1 0-6.18A2.87 2.87 0 0 1 95.64 31.2a2.855 2.855 0 0 1-2.736 3.096M122.172 21h-5.376v15h2.244v-5.688h3.132a4.668 4.668 0 1 0 0-9.312m0 7.2h-3.132v-5.112h3.18a2.57 2.57 0 0 1 2.372 1.585 2.57 2.57 0 0 1-1.389 3.356c-.312.129-.646.195-.983.195zm13.848-2.148a4.19 4.19 0 0 0-3.996 2.292l1.98.828a2.14 2.14 0 0 1 2.052-1.092 2.16 2.16 0 0 1 2.4 1.932v.144a5 5 0 0 0-2.34-.576c-2.136 0-4.32 1.2-4.32 3.384a3.46 3.46 0 0 0 1.167 2.44 3.47 3.47 0 0 0 2.565.86 3.18 3.18 0 0 0 2.856-1.464h.072V36h2.16v-5.772c0-2.628-1.992-4.152-4.548-4.152zm-.276 8.22c-.732 0-1.752-.372-1.752-1.272 0-1.2 1.272-1.608 2.4-1.608a4 4 0 0 1 2.04.504 2.71 2.71 0 0 1-2.64 2.4zm12.744-7.872-2.568 6.504h-.072l-2.664-6.504h-2.4l3.996 9.096-2.28 5.052h2.34l6.144-14.148zm-20.16 9.6h2.232V21h-2.232z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Google_svg__a)",
  d: "M12.528 9.048a2.4 2.4 0 0 0-.564 1.68v26.544c-.04.613.162 1.216.564 1.68l.084.096L27.48 24.18v-.36L12.612 8.964z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Google_svg__b)",
  d: "m32.4 29.136-4.92-4.956v-.36l4.92-4.956.108.072 5.892 3.336c1.68.948 1.68 2.508 0 3.468l-5.868 3.336z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Google_svg__c)",
  d: "M32.544 29.064 27.48 24 12.528 38.952a1.944 1.944 0 0 0 2.484.084z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Google_svg__d)",
  d: "m32.544 18.936-17.532-9.96a1.93 1.93 0 0 0-2.484.072L27.48 24z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "m32.4 28.956-17.388 9.9a1.99 1.99 0 0 1-2.4 0l-.084.084.084.096a1.99 1.99 0 0 0 2.4 0l17.532-9.972z",
  opacity: 0.2
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M12.528 38.784A2.4 2.4 0 0 1 12 37.092v.18c-.04.613.162 1.216.564 1.68l.084-.084zM38.4 25.56l-6 3.396.108.108 5.892-3.336A2.1 2.1 0 0 0 39.672 24a2.23 2.23 0 0 1-1.272 1.56",
  opacity: 0.12
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.012 9.144 38.4 22.44A2.23 2.23 0 0 1 39.672 24a2.1 2.1 0 0 0-1.272-1.728L15.012 8.976c-1.668-.96-3.048-.168-3.048 1.752v.18c.036-1.92 1.38-2.712 3.048-1.764",
  opacity: 0.25
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "Google_svg__a",
  x1: 26.16,
  x2: 6.024,
  y1: 10.452,
  y2: 30.588,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00A0FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#00A1FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#00BEFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#00D2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#00DFFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00E3FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Google_svg__b",
  x1: 40.596,
  x2: 11.568,
  y1: 24,
  y2: 24,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.41,
  stopColor: "#FFBD00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "orange"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF9C00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Google_svg__c",
  x1: 29.796,
  x2: 2.484,
  y1: 26.76,
  y2: 54.06,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF3A44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C31162"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Google_svg__d",
  x1: 8.76,
  x2: 20.952,
  y1: 0.216,
  y2: 12.408,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#32A071"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.07,
  stopColor: "#2DA771"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#15CF74"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#06E775"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00F076"
})))));
export default SvgGoogle;